import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { getBoundingBox } from '@/pages/AdvancedEditor/utils/getBoundingBox';
import { ElementsArray, ElementType, GroupElementType } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

const alignCenter = (element: ElementType, centerX: number) => {
    const box = getBoundingBox(element);
    const offsetX = (box.maxX - box.minX) / 2 - (element.x - box.minX);
    element.set({ x: centerX - offsetX });
};

export function alignElementsCenter(store: StoreType, elements: ElementsArray) {
    const centerX =
        elements.length > 1
            ? (Math.max(...elements.map(getBoundingBox).map(box => box.maxX)) +
                  Math.min(...elements.map(getBoundingBox).map(box => box.minX))) /
              2
            : store.width / 2;

    elements.forEach(element => {
        alignCenter(element, centerX);

        if (element.type === polotnoTypes.Group) {
            (element as GroupElementType).children.forEach((child: ElementType) => {
                alignCenter(child, centerX);
            });
        }
    });
}
